



































import { LayoutModule } from "@/store/layout";
import { Component, Vue, Watch } from "vue-property-decorator";
import Size from "@/models/size";
import SizesAPI from "@/services/sizes";
import TableActions from "@/components/TableActions.vue";
import { Meta } from "@/models/general";
import { get } from "lodash";

@Component({
  components: { TableActions },
})
export default class Sizes extends Vue {
  headers = [
    {
      text: this.$t("sizes.model.name"),
      value: "name",
    },
    {
      text: this.$t("sizes.model.description"),
      value: "description",
    },
    {
      text: "",
      value: "actions",
    },
  ];

  sizes: Size[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;

  created(): void {
    this.getSizes();
  }

  async getSizes(): Promise<void> {
    this.loading = true;
    try {
      const r = await SizesAPI.getSizes(
        this.meta.pagination.current,
        this.meta.pagination.size
      );
      this.sizes = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }

  editSize(id: string): void {
    this.$router.push({ name: "editSize", params: { id } });
  }

  deleteSize(id: string): void {
    LayoutModule.setDialogTitle("sizes.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await SizesAPI.deleteSize(id);
        await this.getSizes();
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getSizes();
  }
}
